import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const School = ({superAdminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [schoolData, setSchoolData] = useState([])
  const [allSchoolDataSheet, setAllSchoolDataSheet] = useState("")
  const [lang, setLang] = useState(superAdminInfo.test.lang.sort()[0]);
  const [region, setRegion] = useState("");
  const [schoolName, setschoolName] = useState("");
  const [std, setStd] = useState("All");

  const { t } = useTranslation();
  
  useEffect(() => {
    if(superAdminInfo.test){

      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getSchoolData = async(testId, superAdminId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/school?testId="+testId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("School Data: ",response.data)
            const schoolData = response.data["schools"]
            setSchoolData(schoolData)
            // console.log(schoolData)
            if(schoolData.length){
              const stds = [...new Set(schoolData.map(item => item.std))].sort()
              const langs = Object.keys(schoolData[0].counts)
              // console.log(langs)
              const stdWiseHeaders = stds.map(std => (langs.map((lang, i) => {
                let temp = []
                if(i===0) temp.push({ "label": "Grade " + std + " Student Count", "key": "grade" + std + "StudentCount" })
                temp.push({ "label": "Grade " + std + " " + lang + " Tested Count", "key": "grade" + std + lang + "RecCount" })
                return temp
              }).reduce((acc, item) => {
                return [
                  ...acc,
                  ...item
                ]
              }, [])))
              // console.log(stdWiseHeaders)
              const allSchoolHeaders = [
                { label: "School Name", key: "name" },
                { label: "Region", key: "region" },
                { label: "Shift", key: "shift" },
                { label: "Number Of Sections", key: "sectionCount" },
                { label: "All Student Count", key: "studentCount" }
              ].concat(
                langs.map((lang) => {
                  return { label: "All " + lang + " Tested Count", key: lang + "RecCount"}
                }
              )).concat(...stdWiseHeaders)
              // console.log(allSchoolHeaders)
              const allSchoolData = [...new Set(schoolData.map(item => item.schoolId))].map(schoolId => {
                                      let school = schoolData.filter(item => item.schoolId === schoolId)
                                      let stdWiseCounts = {}
                                      stds.forEach(std => {
                                        let stdSchool = school.filter(item => item.std === std)[0]
                                        stdWiseCounts[`grade${std}StudentCount`] = stdSchool ? stdSchool.counts[langs[0]].studentCount : 0
                                        langs.forEach((lang) => {
                                          stdWiseCounts[`grade${std}${lang}RecCount`] = stdSchool ? stdSchool.counts[lang].recCount : 0
                                        })
                                      })
                                      // console.log(stdWiseCounts)
                                      
                                    let counts = school.reduce((acc, item) => {
                                      return {
                                        "sectionCount": acc.sectionCount + item.sectionCount,
                                        "studentCount": acc.studentCount + item.counts[langs[0]].studentCount,
                                      }
                                    }, {"sectionCount": 0, studentCount: 0})
                                    langs.forEach((lang) => {
                                      counts = {...counts, 
                                        [`${lang}RecCount`] : school.reduce((acc, item) => {
                                                                return acc + item.counts[lang].recCount
                                                              }, 0)
                                      }
                                    })
                                    // console.log(stdWiseCounts)
                                    return {
                                        ...school[0],
                                        ...counts,
                                        ...stdWiseCounts
                                      }
                                    })
              // console.log(allSchoolData)
              setAllSchoolDataSheet({"headers": allSchoolHeaders, "data": allSchoolData})
            }
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
        getSchoolData(superAdminInfo.test ? superAdminInfo.test.testId : null, superAdminInfo.superAdmin.superAdminId)
        
      })
      .catch((err) => console.log(err));
    }
    else alert("Test has not started yet")
    
  }, [superAdminInfo]);
  
  const columns = [
    {
      key: "name",
      headerName: t("commonItems.tableHeader_school"),
      width: 120
    },
    {
      key: "shift",
      headerName: t("commonItems.tableHeader_shift"),
      width: 40
    },
    { 
      key: "region", 
      headerName: t("commonItems.tableHeader_region"), 
      width: 80 
    },
    {
      key: "sectionCount",
      headerName: t("commonItems.tableHeader_noOfSections"),
      width: 80
    },
    { 
      key: "studentCount", 
      headerName: t("commonItems.tableHeader_studentsCount"), 
      width: 40 
    },
    // {
    //   key: "recCount",
    //   headerName: "Students Tested Count - " + superAdminInfo.allLangs[lang],
    //   width: 80
    // },
    {
      key: "recPercent",
      headerName: t("commonItems.tableHeader_studentsTested") + " - " + superAdminInfo.allLangs[lang] + " (%)",
      width: 120,
      percent: true
    }
  ];

  // if(superAdminInfo?.test?.status === 3) columns.push({
  //   key: "viewPercent",
  //   headerName: "Intervention Material Viewed - " + superAdminInfo.allLangs[lang] + " (%)",
  //   width: 80,
  //   percent: true
  // })

  const headers = [
    { label: "School Name", key: "name" },
    { label: "Shift", key: "shift" },
    { label: "Region", key: "region" },
    { label: "Number Of Sections", key: "sectionCount" },
    { label: "Students Count", key: "studentCount" },
    { label: "Students Tested Count - " + superAdminInfo.allLangs[lang], key: "recCount" },
    { label: "Students Tested - " + superAdminInfo.allLangs[lang] + " (%)", key: "recPercent" },
    // { label: "Intervention Material File Count - " + superAdminInfo.allLangs[lang], key: "fileCount" },
    // { label: "Intervention Material View Count - " + superAdminInfo.allLangs[lang], key: "viewCount" },
    // { label: "Intervention Material Viewed - " + superAdminInfo.allLangs[lang] + " (%)", key: "viewPercent" },
  ];

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };
  
  const handleRegionChange = (e) => {
    setschoolName("")
    setRegion(e.target.value);
  };
  
  const handleSchoolNameChange = (e) => {
    setschoolName(e.target.value);
  };

  const handleStdChange = (e) => {
    setStd(e.target.value);
  };

  var filteredSchoolData
  if(lang && std==="All"){
    filteredSchoolData = schoolData
  }
  else filteredSchoolData = [...schoolData.filter(item => item.std === std)]
  
  // var filteredSchoolData
  // if(region==="" || (region==="" && schoolName==="")){
  //   filteredSchoolData = filteredStdSchoolData
  // }
  if(region!=="" && schoolName===""){
    filteredSchoolData = [...filteredSchoolData.filter(item => item.region === region)]
  }
  else if(region!=="" && schoolName!==""){
    filteredSchoolData = [...filteredSchoolData.filter(item => item.region === region && item.name === schoolName)]
  }
  
  var counts = {
    studentCount: 0,
    ...superAdminInfo.test.lang.sort().reduce((acc, lang) => {
      acc[`${lang}RecCount`] = 0; // Create a key for each language with value 0
      return acc;
    }, {})
  };
  if(superAdminInfo && superAdminInfo.test) {
    let langs = superAdminInfo.test.lang.sort()
    counts.studentCount = filteredSchoolData.reduce((acc, item) => {
      return acc + item.counts[langs[0]].studentCount
    }, 0)
    
    langs.forEach(lang => {
      counts[`${lang}RecCount`] = filteredSchoolData.reduce((acc, item) => {
      return acc + item.counts[lang].recCount
    }, 0)
    });
  }
  // console.log(counts)
  // console.log(schoolData)
  // console.log(filteredSchoolData)

  return (
    <div className="schoolContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("superAdmin.school.title")}{superAdminInfo.test ? <span> - {superAdminInfo.test.testName}</span>: ""}
      </h2>
      <div className="countTileContainer">
        <div className="countTile">
          <div className="countTileLeft">{t("commonItems.countTile_StudentCount")}:</div>
          <div className="countTileRight">{counts.studentCount.toLocaleString("hi")}</div>
        </div>
        {superAdminInfo && superAdminInfo.test &&
          superAdminInfo.test.lang.sort().map((lang, i) => {
            return <div className="countTile" key={i}>
                    <div className="countTileLeft">{t("commonItems.countTile_TestedCount")} - {superAdminInfo.allLangs[lang]}:</div>
                    <div className="countTileRight">{counts[`${lang}RecCount`].toLocaleString("hi")}</div>
                  </div>
          })
        }
      </div>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {superAdminInfo.test &&
                superAdminInfo.test.lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{superAdminInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 80}} size="small">
            <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
            <Select
              labelId="stdFilterLabel"
              id="stdFilter"
              value={std}
              onChange={handleStdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_class")}
            >
              <MenuItem value="All">
                All
              </MenuItem>
              {/* getting all unique std values from data */}
              {schoolData &&
                [...new Set(schoolData.map(item => item.std))].sort((a, b) => a - b).map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
            <Select
              labelId="regionFilterLabel"
              id="regionFilter"
              value={region}
              onChange={handleRegionChange}
              autoWidth
              label={t("commonItems.dropdownLabel_region")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique region values from data */}
              {[...new Set(schoolData.map(item => item.region))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="schoolNameFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
            <Select
              labelId="schoolNameFilterLabel"
              id="schoolNameFilter"
              value={schoolName}
              onChange={handleSchoolNameChange}
              autoWidth
              label={t("commonItems.dropdownLabel_school")}
            >
              {region===""? 
                <MenuItem disabled>Select Region First</MenuItem>
                :
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
              }
              {[...new Set(schoolData.filter(item => item.region === region).map(item => item.name))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
        {allSchoolDataSheet ? 
          <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ marginLeft: "auto" }}>
            <CSVLink data={allSchoolDataSheet.data} headers={allSchoolDataSheet.headers} filename={"AllSchoolDataWithClasses.csv"}>
              {t("superAdmin.school.buttonLabel_csvDownloadAllSchools")}
            </CSVLink>
          </Button>
          :
          <Button disabled variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ marginLeft: "auto" }}>
            {t("superAdmin.school.buttonLabel_csvDownloadAllSchools")}
          </Button>
        }
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink 
            data={(std==="All") ?
                [...new Set(filteredSchoolData.map(item => item.schoolId))].map(schoolId => {
                  let stdSchools= filteredSchoolData.filter(item => item.schoolId === schoolId)
                  let counts = stdSchools.reduce((acc, item) => {
                    return {
                      "sectionCount": acc.sectionCount + item.sectionCount,
                      "studentCount": acc.studentCount + item.counts[lang].studentCount,
                      "recCount": acc.recCount + item.counts[lang].recCount,
                      "fileCount": acc.fileCount + item.counts[lang].fileCount,
                      "viewCount": acc.viewCount + item.counts[lang].viewCount,
                    }
                  }, {"sectionCount": 0, "studentCount": 0, "recCount": 0, "fileCount": 0, "viewCount": 0 })
                  return {
                    ...stdSchools[0],
                    ...counts,
                    "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                    "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                  }
                })
              :
                filteredSchoolData.map(item => {
                  let counts = item.counts[lang]
                  return {
                    ...item,
                    ...counts,
                    "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                    "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                  }
                })
            }
            headers={headers} 
            filename={(std !== "All" ? ("Class-" + std + "_" ) : "") + (region ? region : "All") + (schoolName ? "_" + schoolName : "") + "-SchoolData - " + superAdminInfo.allLangs[lang] + ".csv"}
          >
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={(std==="All") ?
              [...new Set(filteredSchoolData.map(item => item.schoolId))].map(schoolId => {
                let stdSchools= filteredSchoolData.filter(item => item.schoolId === schoolId)
                let counts = stdSchools.reduce((acc, item) => {
                  return {
                    "sectionCount": acc.sectionCount + item.sectionCount,
                    "studentCount": acc.studentCount + item.counts[lang].studentCount,
                    "recCount": acc.recCount + item.counts[lang].recCount,
                    "fileCount": acc.fileCount + item.counts[lang].fileCount,
                    "viewCount": acc.viewCount + item.counts[lang].viewCount,
                  }
                }, {"sectionCount": 0, "studentCount": 0, "recCount": 0, "fileCount": 0, "viewCount": 0 })
                return {
                  ...stdSchools[0],
                  ...counts,
                  "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                  "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                }
              })
            :
              filteredSchoolData.map(item => {
                let counts = item.counts[lang]
                return {
                  ...item,
                  ...counts,
                  "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                  "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                }
              })
          }
          orderBy={["recPercent", "viewPercent", "studentCount"]} 
          tableHeight="calc(100vh - 390px)"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default School;